import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { useAppSelector } from "../../../../../redux";
import "./PartnerShortDetails.scss";

const PartnerShortDetails: React.FC = () => {
  const { partnerDetails } = useAppSelector((state) => state.partner_details);

  if (!partnerDetails) return null;

  const partnerTypeLabel = Array.isArray(partnerDetails.partner_type)
    ? partnerDetails.partner_type.join(", ")
    : partnerDetails.partner_type || "—";

  return (
    <div className="partner-short-details">
      <div className="partner-logo">
        <Iconography icon="circleUserFilled" size={IconographySizes.Medium} />
      </div>
      <div className="name-and-details">
        <div className="name">{partnerDetails.partner_name}</div>
        {/* <div className="details">
          <div className="id">
            <p>Partner ID:</p>
            <span>{partnerDetails.partner_id}</span>
          </div>
          <div className="tag partner-type">
            <span>Partner Type: {partnerTypeLabel}</span>
          </div>
          <div className="tag status">
            <span>Status: {partnerDetails.status}</span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default PartnerShortDetails;
